import React, { useState, useEffect } from "react";
import { FaShareAlt } from "react-icons/fa";
import ShareModal from "../ShareModal/ShareModal";
import { trackLandingVisitApi } from "../../utils/shareTracking";
import "./ShareBlogButton.css";

const ShareBlogButton = ({ blog }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Auto-resolve blog details if only partial info is passed
  const resolvedBlog = {
    id: blog?.id || blog?.slug || "blog",
    title: blog?.title || document.title.split("|")[0].trim() || "Blog Post",
    path: blog?.path || (typeof window !== "undefined" ? window.location.pathname : ""),
    category: blog?.category || "Blog Article"
  };

  // Track campaign landing visit on page load if UTM query parameters exist
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.search) {
      trackLandingVisitApi({
        contentType: "blog",
        blogId: resolvedBlog.id,
        blogTitle: resolvedBlog.title,
        blogPath: resolvedBlog.path,
        projectId: resolvedBlog.id,
        projectTitle: resolvedBlog.title,
        projectPath: resolvedBlog.path
      });
    }
  }, [resolvedBlog.id, resolvedBlog.title, resolvedBlog.path]);

  return (
    <>
      <button
        type="button"
        className="visit-project-button share-blog-btn"
        onClick={() => setIsModalOpen(true)}
        aria-label={`Share ${resolvedBlog.title}`}
        title="Share Blog with Tracking Links"
      >
        <span className="share-btn-icon">
          <FaShareAlt />
        </span>
        <span className="share-btn-text">Share Blog</span>
      </button>

      <ShareModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        item={resolvedBlog}
        contentType="blog"
      />
    </>
  );
};

export default ShareBlogButton;
